import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  SignupRequestPayload,
  VerifyUserVerificationCodeRequestPayload,
  ResendUserVerificationCodeRequestPayload,
  OnBoardingRequest,
  OnboardingSubmitRequest,
} from '../../types';
import type { AvailableSlotsResponse } from '../../types';
import {
  signup,
  verifyUserVerificationCode,
  resendUserVerificationCode,
  onBoardingDetails,
  submitOnboarding,
  getAvailableSlots,
  getAnonymousUserHash,
} from '../../helpers/auth.api';
import {
  ResponseErrorWithHandled,
  ResponseSuccess,
} from '../../../../shared/types';

export const signupRequest = createAsyncThunk<
  ResponseSuccess,
  SignupRequestPayload,
  { rejectValue: ResponseErrorWithHandled }
>('signup/signupRequest', async (args, thunkAPI) => {
  try {
    return await signup(args);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const verifyUserVerificationCodeRequest = createAsyncThunk<
  ResponseSuccess,
  VerifyUserVerificationCodeRequestPayload,
  { rejectValue: ResponseErrorWithHandled }
>('signup/verifyUserVerificationCodeRequest', async (args, thunkAPI) => {
  try {
    return await verifyUserVerificationCode(args);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const resendUserVerificationCodeRequest = createAsyncThunk<
  ResponseSuccess,
  ResendUserVerificationCodeRequestPayload,
  { rejectValue: ResponseErrorWithHandled }
>('signup/resendUserVerificationCodeRequest', async (args, thunkAPI) => {
  try {
    return await resendUserVerificationCode(args);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const onboardingDetailsRequest = createAsyncThunk<
  ResponseSuccess,
  OnBoardingRequest,
  { rejectValue: ResponseErrorWithHandled }
>('signup/onboardingDetailsRequest', async (args, thunkAPI) => {
  try {
    return await onBoardingDetails(args);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const submitOnboardingRequest = createAsyncThunk<
  ResponseSuccess,
  OnboardingSubmitRequest,
  { rejectValue: ResponseErrorWithHandled }
>('signup/submitOnboardingRequest', async (args, thunkAPI) => {
  try {
    return await submitOnboarding(args);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const getAvailableSlotsRequest = createAsyncThunk<
  AvailableSlotsResponse,
  { startTime?: string } | void,
  { rejectValue: ResponseErrorWithHandled }
>('signup/getAvailableSlotsRequest', async (arg, thunkAPI) => {
  try {
    const params =
      arg && typeof arg === 'object' && arg.startTime
        ? { startTime: arg.startTime }
        : undefined;
    const res = await getAvailableSlots(params);
    return (res as unknown) as AvailableSlotsResponse;
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const getAnonymousUserHashRequest = createAsyncThunk<
  ResponseSuccess,
  void,
  { rejectValue: ResponseErrorWithHandled }
>('signup/getAnonymousUserHashRequest', async (_, thunkAPI) => {
  try {
    return await getAnonymousUserHash();
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});
